import PropTypes from "prop-types";
import React, { useState } from "react";

const TextField = ({
                       className = "",
                       inputClassName = "",
                       labelClassName = "",
                       label = "",
                       value,
                       defaultValue = "",
                       onChange,
                       onBlur,
                       onFocus,
                       onKeyDown,
                       onKeyPress,
                       onKeyUp,
                       onClick,
                       onDoubleClick,
                       onMouseDown,
                       onMouseEnter,
                       onMouseLeave,
                       onMouseMove,
                       onMouseOut,
                       onMouseOver,
                       onMouseUp,
                       ...props
                   }) => {
    const [internalValue, setInternalValue] = useState(defaultValue);
    const handleChange = (e) => {
        if (onChange) {
            onChange(e);
        }
        setInternalValue(e.target.value);
    };

    const inputValue = value !== undefined ? value : internalValue;

    return (
        <div className={`input-wrapper ${className}`}>
            {label && <label className={labelClassName}>{label}</label>}
            <input
                type="text"
                className={inputClassName}
                value={inputValue}
                onChange={handleChange}
                onBlur={onBlur}
                onFocus={onFocus}
                onKeyDown={onKeyDown}
                onKeyPress={onKeyPress}
                onKeyUp={onKeyUp}
                onClick={onClick}
                onDoubleClick={onDoubleClick}
                onMouseDown={onMouseDown}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onMouseMove={onMouseMove}
                onMouseOut={onMouseOut}
                onMouseOver={onMouseOver}
                onMouseUp={onMouseUp}
                {...props}
            />
        </div>
    );
};

TextField.propTypes = {
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    onKeyPress: PropTypes.func,
    onKeyUp: PropTypes.func,
    onClick: PropTypes.func,
    onDoubleClick: PropTypes.func,
    onMouseDown: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onMouseMove: PropTypes.func,
    onMouseOut: PropTypes.func,
    onMouseOver: PropTypes.func,
    onMouseUp: PropTypes.func,
};

export default TextField;